import { render } from "./BelongsToField.vue?vue&type=template&id=3b5b3a41"
import script from "./BelongsToField.vue?vue&type=script&lang=js"
export * from "./BelongsToField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BelongsToField.vue"]])

export default __exports__